import { IUpdateDependenteUseCase } from "../../../presentation/useCases/update/update_dependente_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateDependenteUseCase
 */

export class UpdateDependenteUseCase implements IUpdateDependenteUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateDependente(
    idFuncionarioDependente: number,
    nome: string,
    dataNascimento: Date | null,
    cpf: string,
    rg: string,
    grauParentesco: string,
  ): Promise<void> {
    await this.repository.updateDependente(
      idFuncionarioDependente,
      nome,
      grauParentesco,
      rg,
      cpf,
      dataNascimento ? dataNascimento.toISOString() : null,
    );
  }
}